export default __webpack_public_path__ + "static/media/range-date.1657f778.png";